import axios from 'axios'
import React, { useState, useEffect, useMemo, Fragment, useRef } from 'react'
import { FormControl, InputLabel, Input, FormHelperText, Alert, Divider } from '@mui/material'
import WebService from '@util/webService'
import { encodeParams, getAction, printVariable } from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux'
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField, withStyles, InputBase } from '@mui/material'
import { styled, alpha } from '@mui/material/styles'
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton'
import useSnackbar from '@hooks/useSnackbar'
import MyTableHead from '@components/MyTableHead'
import useIndicator from '@hooks/useIndicator'
import Indicator from '@components/Indicator'
import MyDialog from '@components/MyDialog'
import useForm from '@hooks/useForm'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
// pagination
import { useTheme } from '@mui/material/styles'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import LastPageIcon from '@mui/icons-material/LastPage'
import ControlPointIcon from '@mui/icons-material/ControlPoint'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
// date
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import 'dayjs/locale/ko'
import moment from 'moment'
import useAlert from '@hooks/useAlert'
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import { Avatar, Grid, Container } from '@mui/material/'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import { searchSchool } from '@util/helper'
import { act } from 'react-dom/test-utils'
import useDelegate from '@hooks/useDelegate'
import { GlobalStyle as gs } from '@src/GlobalStyle'

const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`
const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
  font-size: 0.85rem !important;
`
const ManagerSmstPart = ({ fields, record, callback, dgRef }) => {
  console.log('ManagerSmstPart rendering....')
  console.log('record =================>', record)
  const inputRef = useRef()
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const [detailScreen, set_detailScreen] = useState(false)

  const visibleColumns = fields.filter((col) => col.visible)
  const defRecord = {}
  fields.forEach((d) => {
    defRecord[d.field] = d.value
  })
  defRecord.schoolList = []
  const defTerms = {}
  const [count, set_count] = useState(0)
  fields
    .filter((col) => col.canSrch)
    .map((d) => d.field)
    .forEach((d) => (defTerms[d] = ''))

  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const [terms, _set_terms] = useState(defTerms)
  const termsRef = useRef(terms)
  const updateRef = useRef(false)
  const { alert, renderAlert } = useAlert()
  // redux
  const codeGroups = useSelector((state) => state.codeGroupReducer)
  const codes = useSelector((state) => state.codeReducer)
  const schools = useSelector((state) => state.schoolReducer)
  const account = useSelector((state) => state.accountReducer)
  const schola = useSelector((state) => state.scholaReducer)
  const allOffCodes = codes.filter(r => r.codeGroupId === 'SA29').filter(r => r.code !== 'F000').sort((a, b) => a.sqNum - b.sqNum)
  // const [lectured, set_lectured] = useState(true)
  const [error, set_error] = useState('')
  const [prevSmstList, set_prevSmstList] = useState([])

  const fetchPrevSmstList = async () => {
    const url = `/smst/prev/list/${schola.id}/${record.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    } else {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      records.unshift({ id: 0, gisu: '없음' })
      return records
    }
  }

  const onLoad = async () => {
    // openIndicator()
    // if(+record.id === -1) {
    //   set_lectured(false)
    // }
    // else {
    //   const lecutres = await fetchLectures(record.id)
    //   if(lecutres && lecutres.length == 0) {
    //     set_lectured(false)
    //   }
    //   if(record.phase > 0) {
    //     set_lectured(false)
    //   }
    // }
    //
    // closeIndicator()
    //
    const prevSmstList = await fetchPrevSmstList()
    console.log('prevSmstList', prevSmstList)
    if (prevSmstList) {
      set_prevSmstList(prevSmstList)
    }
  }
  const handleClose = (event, reason) => {
    if(reason && reason === 'backdropClick') {
      return
    }
    dgRef.current.close()

    if (callback) {
      callback(updateRef.current)
    }
  }
  const canEdit = () => {
    if (record.phase <= 0) {
      return true
    }

    return false
  }

  useEffect(() => {
    onLoad()
  }, [record])

  const selCodeList = useMemo(() => codes.filter((r) => r.codeGroupId === 'SA07'))
  const overCodeList = useMemo(() => codes.filter((r) => r.codeGroupId === 'SC07'))
  const fetchLectures = async () => {
    const url = `/lecture/smst/${record.id}`
    const resp = await WebService.get(url)
    if (resp.repCode !== 'ack') {
      openSnackbar(resp.repMessage)
      return undefined
    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.records)
  }

  const onSubmit = async () => {
    const url = record.copy ? `/smst/copy/${record.copy.id}` : '/smst'
    console.log('url => ', url)
    const data = { ...factor }
    console.log('data=>', data)
    const regiStime = moment(data.regiStime1).format('YYYY-MM-DD') + ' ' + data.regiStime2 + ':00:00'
    const regiEtime = moment(data.regiEtime1).format('YYYY-MM-DD') + ' ' + data.regiEtime2 + ':00:00'
    const regiFtime = moment(data.regiFtime1).format('YYYY-MM-DD') + ' ' + data.regiFtime2 + ':00:00'

    let regiAtime = null
    if (data.regiAtime1 || data.regiAtime2) {
      if (!data.regiAtime1 || !data.regiAtime2) {
        alert('추가모집일 또는 시간에 오류가 있습니다.')
        return
      }
      regiAtime = moment(data.regiAtime1).format('YYYY-MM-DD') + ' ' + data.regiAtime2 + ':00:00'
    }

    data.regiStime = regiStime
    data.regiEtime = regiEtime
    data.regiFtime = regiFtime
    data.regiAtime = regiAtime
    data.offCodes = activeRow.offCodes
    data.lectureEtime = moment(data.lectureEtime).format('YYYY-MM-DD') + ' ' + '23:59:59'

    openIndicator()
    const resp = await WebService.post(url, data)
    closeIndicator()
    if (resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const smst = JSON.parse(repMessage.record)
      activeRow.id = smst.id
      factor.id = smst.id
      // handleChange({target:{name:'id', value:smst.id}})
      handleChange()
      onLoad()
      updateRef.current = true
      alert('저장되었습니다.', () => handleClose())
    } else {
      alert(resp.repMessage)
    }
  }

  const checkDatetime = (trigger) => {
    // const times = ['regiStime1', 'regiStime2', 'regiEtime1', 'regiEtime2', 'lectureStime', 'lectureEtime', 'regiAtime1', 'regiAtime2']

    // times
    //   .filter(r => r !== trigger) // trigger와 같지 않은 요소만 추출
    //   .forEach(t => {             // 여기 변수를 t로 받았다면
    //     console.log('checking =>', t) // 로그에서도 t를 써야 합니다
    //     handleChange({ target: { name: t, value: factor[t] } })
    //   })
    handleChange({ target: { name: 'error', value: '' } })

  }


  const validate = async (name, value) => {
    let err = ''
    const regex = /^(?:[01]\d|2[0-3])$/
    if (name === 'regiStime2' || name === 'regiEtime2' || name === 'regiFtime2') {
      if (!regex.test(value)) {
        err = '00, 01, 02,..., 23 형식으로 입력하세요.'
      }
    }
    if (name === 'regiAtime2') {
      if (value) {
        if (!regex.test(value)) {
          err = '00, 01, 02,..., 23 형식으로 입력하세요.'
        }
      }
    }

    if (name === 'year') {
      if (!moment(value, 'YYYY', true).isValid()) {
        err = `년도 값이 올바르지 않습니다.`
      }
    }
    if (name === 'regiStime1' || name === 'regiEtime1' || name === 'regiFtime1' || name === 'lectureStime' || name === 'lectureEtime') {
      // if(name === 'regiStime1' ) {
      if (!moment(value, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
        // if(!moment(value, 'YYYY-MM-DD', true).isValid()) {
        err = `날짜 값이 올바르지 않습니다.`
      }
    }
    if (name === 'regiAtime1') {
      if (value) {
        if (!moment(value, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
          err = `날짜 값이 올바르지 않습니다.`
        }
      }
    }

    if (name === 'gisu') {
      if (!value) {
        err = '기수 값이 비어 있습니다.'
      }
    }
    if (name === 'selCode') {
      if (!value) {
        err = '선발방식을 선택하세요.'
      }
    }
    if (name === 'overCode') {
      if (!value || value === 'V001') {
        if (factor['selCode'] === 'S001') {
          err = '기수강자우선일 경우 정원초과시 선발방식을 선택하세요.'
        }
      }
    }

    if (name === 'prevId') {
      if (!value || +value === 0) {
        if (factor.selCode === 'S001') {
          err = '선발방식 기수강자 우선일 경우에는 이전기수를 반드시 선택해야 합니다.'
        }
      }
    }

    if (name === 'offCodes') {
      if (value.length === 0) {
        if (factor.consentYn === 'Y') {
          err = '동의받을 귀가방법을 한 개 이상 선택해야 합니다.'
        }
      }
    }

    if (name === 'error') {
      console.log('full error checking....')
      const regiStime = moment(factor.regiStime1, 'YYYY-MM-DD HH:mm:ss')
      const regiEtime = moment(factor.regiEtime1, 'YYYY-MM-DD HH:mm:ss')
      const regiFtime = moment(factor.regiFtime1, 'YYYY-MM-DD HH:mm:ss')
      const lectureStime = moment(factor.lectureStime, 'YYYY-MM-DD HH:mm:ss')
      const lectureEtime = moment(factor.lectureEtime, 'YYYY-MM-DD HH:mm:ss')
      const regiEndTime = moment(moment(factor.regiEtime1).format('YYYY-MM-DD') + ' ' + factor.regiEtime2 + ':00:00', 'YYYY-MM-DD HH:mm:ss')
      const regiFinTime = moment(moment(factor.regiFtime1).format('YYYY-MM-DD') + ' ' + factor.regiFtime2 + ':00:00', 'YYYY-MM-DD HH:mm:ss')

      let regiAtime = null
      if (factor.regiAtime1 || factor.regiAtime2) {
        if (!factor.regiAtime1 || !factor.regiAtime2) {
          err = '추가모집일 또는 시간에 오류가 있습니다.'
          return
        }
        regiAtime = moment(moment(factor.regiAtime1).format('YYYY-MM-DD') + ' ' + factor.regiAtime2 + ':00:00', 'YYYY-MM-DD HH:mm:ss')
      }

      if (!regiStime.isBefore(regiEtime)) {
        err = '수강신청 시작일은 수강신청 종료일 보다 전이어야 합니다.'
      }
      if (!regiEndTime.isBefore(regiFinTime)) {
        err = '수강신청 종료일시는 수강신청 확정일시 보다 전이어야 합니다.'
      }
      if (!regiFtime.isBefore(lectureStime)) {
        err = '수강신청 확정일은 강좌 시작일 보다 전이어야 합니다.'
      }
      if (!lectureStime.isBefore(lectureEtime)) {
        err = '강좌 시작일은 강좌 종료일 보다 전이어야 합니다.'
      }

      if (regiAtime) {
        if (!regiEtime.isBefore(regiAtime)) {
          err = '수강신청 종료일은  추가모집 종료일 보다 전이어야 합니다.'
        }
        if (!regiAtime.isBefore(lectureStime)) {
          err = `추가모집 종료일은 강좌 시작일보다 전이어야 합니다.`
        }
      }
    }

    return err
  }

  const { activeRow, errors, updateState, handleChange, handleSubmit, factor } = useDelegate({
    initialValues: { ...record },
    onSubmit: onSubmit,
    validate: validate,
  })

  const [emailError, setEmailError] = useState('')
  const [passwordState, setPasswordState] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [nameError, setNameError] = useState('')
  const [registerError, setRegisterError] = useState('')
  const [schoolList, set_schoolList] = useState([])
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } }

  return (
    <Container component="main" maxWidth="lg">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}
      >
        {record.copy ? (
          <>
            <div style={{ marginBottom: 1 }}>
              <Typography variant="h6" style={{ display: 'flex', alignItems: 'center', color: gs.colors.main, fontWeight: 'bold' }}>
                <ContentCopyOutlinedIcon /> &nbsp; 복사 대상: {record.copy.year}년도 {record.copy.gisu}기수 모든 강좌
              </Typography>
            </div>
            <Divider sx={{ margin: 1, width: '100%' }} />
          </>
        ) : null}
        <Typography component="h1" variant="h5">
          기본정보
        </Typography>
        <Boxs component="form" noValidate sx={{ mt: 3 }}>
          <FormControl component="fieldset" variant="standard">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <TextField fullWidth size="small" required label={'학교명'} value={schola.name} aria-readonly />
                  </Grid>
                  <Grid item xs={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                      <DatePicker
                        disabled={!canEdit()}
                        views={['year']}
                        label={'년도'}
                        name={'year'}
                        value={activeRow['year']}
                        inputFormat="YYYY"
                        onChange={(newValue) => {
                          const d = moment(new Date(newValue)).format('YYYY')
                          handleChange({ target: { name: 'year', value: d } })
                          updateState()
                        }}
                        renderInput={(params) => <TextField disabled={!canEdit()} iname={'year'} fullWidth size="small" {...params} />}
                      />
                    </LocalizationProvider>
                    <FormHelperTexts>{errors['year']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      disabled={!canEdit()}
                      fullWidth
                      size="small"
                      required
                      label={'기수'}
                      name={'gisu'}
                      defaultValue={activeRow.gisu}
                      onChange={(e) => {
                        handleChange(e)
                        updateState()
                      }}
                    />
                    <FormHelperTexts>{errors['gisu']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={2}>
                    <FormControl fullWidth>
                      <InputLabel id="selCode">선발방식</InputLabel>
                      <Select
                        disabled={!canEdit()}
                        labelId="selCode"
                        required
                        label="선발방식"
                        name={'selCode'}
                        value={activeRow['selCode']}
                        onChange={(e) => {
                          // 기수강자우선이 아닐 경우
                          if (e.target.value !== 'S001') {
                            handleChange({ target: { name: 'overCode', value: 'V001' } })
                            handleChange({ target: { name: 'prevId', value: '0' } })
                          }

                          handleChange(e)
                          handleChange({ target: { name: 'prevId', value: factor.prevId } })
                          handleChange({ target: { name: 'overCode', value: factor.overCode } })

                          updateState()

                        }}
                      >
                        {selCodeList.map((l, index) => {
                          return (
                            <MenuItem key={index} value={l.code}>
                              {l.name}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>
                    <FormHelperTexts>{errors['selCode']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={2}>
                    <FormControl fullWidth>
                      <InputLabel id="prevId">이전기수</InputLabel>
                      <Select
                        disabled={!canEdit() || activeRow['selCode'] !== 'S001'}
                        labelId="prevId"
                        required
                        label="이전기수"
                        name={'prevId'}
                        value={activeRow['prevId']}
                        onChange={(e) => {
                          handleChange(e)
                          updateState()
                        }}
                      >
                        {prevSmstList.map((l, index) => {
                          return (
                            <MenuItem key={index} value={l.id}>
                              {l.gisu}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>
                    <FormHelperTexts>{errors['prevId']}</FormHelperTexts>
                  </Grid>

                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid item xs={3}>
                  <FormControl fullWidth>
                    <InputLabel id="overCode">기수강자우선일 경우 정원초과시 선발방식</InputLabel>
                    <Select
                      disabled={!canEdit() || activeRow['selCode'] !== 'S001'}
                      labelId="overCode"
                      label="기수강자우선일 경우 정원초과시 선발방식"
                      required
                      name={'overCode'}
                      value={activeRow['overCode']}
                      onChange={(e) => {
                        handleChange(e)
                        updateState()
                      }}
                    >
                      {overCodeList.map((l, index) => {
                        return (
                          <MenuItem key={index} value={l.code}>
                            {l.name}
                          </MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
                  <FormHelperTexts>{errors['overCode']}</FormHelperTexts>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Divider sx={{ margin: 1 }} />
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                      <DatePicker
                        disabled={!canEdit()}
                        label={'수강신청 시작일'}
                        name={'regiStime1'}
                        value={activeRow['regiStime1']}
                        inputFormat="YYYY-MM-DD"
                        onChange={(newValue) => {
                          const dtime = moment(new Date(newValue))
                          const d = dtime.format(dateFormat)
                          activeRow['regiStime1'] = d
                          handleChange({ target: { name: 'regiStime1', value: d } })
                          updateState()
                          checkDatetime('regiStime1')
                        }}
                        renderInput={(params) => <TextField name={'regiStime1'} fullWidth size="small" {...params} />}
                      />
                    </LocalizationProvider>
                    <FormHelperTexts>{errors['regiStime1']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      disabled={!canEdit()}
                      fullWidth
                      size="small"
                      required
                      label={'수강신청 시작시간'}
                      name={'regiStime2'}
                      value={activeRow['regiStime2']}
                      onChange={(e) => {
                        handleChange(e)
                        checkDatetime(['regiStime2'])
                      }}
                    />
                    <FormHelperTexts>{errors['regiStime2']}</FormHelperTexts>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                      <DatePicker
                        disabled={!canEdit()}
                        label={'수강신청 종료일'}
                        name={'regiEtime1'}
                        value={activeRow['regiEtime1']}
                        inputFormat="YYYY-MM-DD"
                        onChange={(newValue) => {
                          const dtime = moment(new Date(newValue))
                          const d = dtime.format(dateFormat)
                          activeRow['regiEtime1'] = d
                          handleChange({ target: { name: 'regiEtime1', value: d } })
                          updateState()
                          checkDatetime('regiEtime1')
                        }}
                        renderInput={(params) => <TextField name={'regiEtime1'} fullWidth size="small" {...params} />}
                      />
                    </LocalizationProvider>
                    <FormHelperTexts>{errors['regiEtime1']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      disabled={!canEdit()}
                      fullWidth
                      size="small"
                      required
                      label={'수강신청 종료시간'}
                      name={'regiEtime2'}
                      value={activeRow['regiEtime2']}
                      onChange={(e) => {
                        handleChange(e)
                        checkDatetime('regiEtime2')
                      }}
                    />
                    <FormHelperTexts>{errors['regiEtime2']}</FormHelperTexts>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                      <DatePicker
                        disabled={!canEdit()}
                        label={'수강신청 확정일'}
                        name={'regiFtime1'}
                        value={activeRow['regiFtime1']}
                        inputFormat="YYYY-MM-DD"
                        onChange={(newValue) => {
                          const dtime = moment(new Date(newValue))
                          const d = dtime.format(dateFormat)
                          activeRow['regiFtime1'] = d
                          handleChange({ target: { name: 'regiFtime1', value: d } })
                          updateState()
                          checkDatetime('regiFtime1')
                        }}
                        renderInput={(params) => <TextField name={'regiFtime1'} fullWidth size="small" {...params} />}
                      />
                    </LocalizationProvider>
                    <FormHelperTexts>{errors['regiFtime1']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      disabled={!canEdit()}
                      fullWidth
                      size="small"
                      required
                      label={'수강신청 확정시간'}
                      name={'regiFtime2'}
                      value={activeRow['regiFtime2']}
                      onChange={(e) => {
                        handleChange(e)
                        checkDatetime('regiFtime2')
                      }}
                    />
                    <FormHelperTexts>{errors['regiFtime2']}</FormHelperTexts>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                      <DatePicker
                        label={'추가모집 종료일(필수아님)'}
                        name={'regiAtime1'}
                        value={activeRow['regiAtime1']}
                        inputFormat="YYYY-MM-DD"
                        onChange={(newValue) => {
                          if (newValue) {
                            const dtime = moment(new Date(newValue))
                            const d = dtime.format(dateFormat)
                            activeRow['regiAtime1'] = d
                            handleChange({ target: { name: 'regiAtime1', value: d } })

                          } else {
                            activeRow['regiAtime1'] = null
                            handleChange({ target: { name: 'regiAtime1', value: null } })
                          }
                          updateState()
                          checkDatetime('regiAtime1')
                        }}
                        renderInput={(params) => <TextField name={'regiAtime1'} fullWidth size="small" {...params} />}
                      />
                    </LocalizationProvider>
                    <FormHelperTexts>{errors['regiAtime1']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={3}>
                    <TextField fullWidth size="small" label={'추가모집 종료시간'} name={'regiAtime2'} value={activeRow['regiAtime2']} onChange={handleChange} />
                    <FormHelperTexts>{errors['regiAtime2']}</FormHelperTexts>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Divider sx={{ margin: 1 }} />
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                      <DatePicker
                        disabled={!canEdit()}
                        label={'강좌 시작일'}
                        name={'lectureStime'}
                        value={activeRow['lectureStime']}
                        inputFormat="YYYY-MM-DD"
                        onChange={(newValue) => {
                          const dtime = moment(new Date(newValue))
                          const d = dtime.format(dateFormat)
                          activeRow['lectureStime'] = d
                          handleChange({ target: { name: 'lectureStime', value: d } })
                          updateState()
                          checkDatetime('lectureStime')
                        }}
                        renderInput={(params) => <TextField name={'lectureStime'} fullWidth size="small" {...params} />}
                      />
                    </LocalizationProvider>
                    <FormHelperTexts>{errors['lectureStime']}</FormHelperTexts>
                  </Grid>
                  <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                      <DatePicker
                        disabled={!canEdit()}
                        label={'강좌 종료일'}
                        name={'lectureEtime'}
                        value={activeRow['lectureEtime']}
                        inputFormat="YYYY-MM-DD"
                        onChange={(newValue) => {
                          const dtime = moment(new Date(newValue))
                          const d = dtime.format(dateFormat)
                          activeRow['lectureEtime'] = d
                          handleChange({ target: { name: 'lectureEtime', value: d } })
                          updateState()
                          checkDatetime('lectureEtime')
                        }}
                        renderInput={(params) => <TextField name={'lectureEtime'} fullWidth size="small" {...params} />}
                      />
                    </LocalizationProvider>
                    <FormHelperTexts>{errors['lectureEtime']}</FormHelperTexts>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <FormHelperTexts>{errors.error}</FormHelperTexts>
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      onChange={(e) => {
                        const v = e.target.checked ? 'Y' : 'N'
                        handleChange({ target: { name: 'autoYn', value: v } })
                        updateState()
                      }}
                      checked={activeRow.autoYn === 'Y'}
                    />
                  }
                  label={'자동 절차 진행'}
                />
                <Typography variant="body2">
                  - 체크된 경우 시간에 따라 모집시작, 모집종료, 추가모집종료, 개강의 변경은 자동으로 진행됩니다. <br />- 이 경우에도 추가모집시작,
                  학생선발(모집인원 초과의 경우), 등록마감, 출석부생성, 종강의 변경은 자동으로 진행되지 않습니다.
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    onChange={(e) => {
                      const v = e.target.checked ? 'Y' : 'N'
                      handleChange({ target: { name: 'allsYn', value: v } })
                      updateState()
                    }}
                    checked={activeRow.allsYn === 'Y'}
                  />
                }
                label={'수강신청 일정 검사'}
              />
              <Typography variant="body2">
                - 체크된 경우 종강 전 모든 학기에 대해서 수강신청 시 학생의 중복일정 검사를 수행합니다. <br />- 체크되지 않은 경우 해당 학기에 대해서만 수강신청
                시 학생의 중복일정 검사를 수행합니다.
              </Typography>
            </Grid>
            {/* <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    onChange={(e) => {
                      const v = e.target.checked ? 'Y' : 'N'
                      handleChange({ target: { name: 'odayYn', value: v } })
                      updateState()
                    }}
                    checked={activeRow.odayYn === 'Y'}
                  />
                }
                label={'수강신청 중복 요일 검사'}
              />
              <Typography variant="body2">
                - 체크된 경우 같은 학기 내 같은 요일 강좌에 중복하여 수강신청할 수 없게 됩니다 (단, 영어 과목 같은 다수 요일 강좌는 타 강좌와 요일 중복 가능).
              </Typography>
            </Grid> */}

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    onChange={(e) => {
                      const v = e.target.checked ? 'Y' : 'N'
                      handleChange({ target: { name: 'upYn', value: v } })
                      updateState()
                    }}
                    checked={activeRow.upYn === 'Y'}
                  />
                }
                label={'수강신청 카운트 다운 노출'}
              />
              <Typography variant="body2">
                - 체크된 경우 수강신청 시작 24시간 전부터 보호자에게 남은 시간 카운트 다운 및 등록된 강좌 들이 오픈됩니다(앱 버전 1.7.2 이상부터 가능).
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    onChange={(e) => {
                      const v = e.target.checked ? 'Y' : 'N'
                      handleChange({ target: { name: 'priorityCutYn', value: v } })
                      updateState()
                    }}
                    checked={activeRow.priorityCutYn === 'Y'}
                  />
                }
                label={'우선신청한 경우에만 선발 우선 적용'}
              />
              <Typography variant="body2">
                - 체크된 경우 선발방식이 기수강자우선이면 수강신청 &gt; 학기준비(우선신청)에 수강신청 시작전에 등록되어 있는 학생만 우선 선발 됩니다.<br/>
                - 학생 선발 이후 복구버튼으로 이전 상태로 되돌리면 다시 학생 선발을 할 수 없게되니 유의하기 바랍니다.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    onChange={(e) => {
                      const v = e.target.checked ? 'Y' : 'N'
                      handleChange({ target: { name: 'consentYn', value: v } })
                      updateState()
                    }}
                    checked={activeRow.consentYn === 'Y'}
                  />
                }
                label={'보호자 수강신청 시 동의 절차 추가'}
              />
              <Typography variant="body2">
                - 체크된 경우 보호자가 수강신청 시 귀가방법 및 학생신변에 관한 동의서를 받는 절차를 추가합니다. <br />
                - 체크된 경우 반드시 아래의 동의받을 귀가방법 목록을 선택해야 합니다. <br />
                - 귀가 방법은 동의 수강신청 시 동의 절차와 무관하게 선택할 수 있습니다.<br />
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container style={{ display: 'flex', alignItems: 'center' }}>
                <Grid item xs={2} style={{ display: 'flex', }}>
                  <Typography variant='body1'>귀가방법 목록:</Typography>
                </Grid>
                <Grid item xs={10}>
                  {
                    allOffCodes.map(r => (
                      <FormControlLabel
                        sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.875rem' } }}
                        control={
                          <Checkbox
                            color="primary"
                            onChange={(e) => {
                              const offCodes = [...activeRow.offCodes]
                              if (e.target.checked) {
                                if (!offCodes.includes(r.code)) {
                                  offCodes.push(r.code)
                                }
                              }
                              else {
                                const idx = offCodes.findIndex(code => code == r.code)
                                if (idx >= 0) {
                                  offCodes.splice(idx, 1)
                                }
                              }
                              activeRow.offCodes = offCodes
                              console.log('offCodes=>', offCodes)
                              handleChange({
                                target: {
                                  name: 'offCodes',
                                  value: offCodes
                                }
                              })
                              updateState()
                            }}
                            checked={activeRow.offCodes.includes(r.code)}
                          />
                        }
                        label={r.name}
                      />
                    ))
                  }
                </Grid>
              </Grid>
              <FormHelperTexts>{errors['offCodes']}</FormHelperTexts>
            </Grid>
          </FormControl>
          <FormHelperTexts>{registerError}</FormHelperTexts>
        </Boxs>
      </Box>

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Button variant="outlined" onClick={handleClose} sx={{ mt: 5, mr: 1 }}>
          닫기
        </Button>
        <Button variant="contained" onClick={handleSubmit} sx={{ mt: 5, mr: 1 }}>
          저장
        </Button>
      </div>

      {renderIndicator()}
      {renderAlert()}
    </Container>
  )
}
export default ManagerSmstPart
